import { useEffect, useState } from "react";
import { api } from "../api/client";

/**
 * 15.08: live-поиск клиента по номеру из create-модалки брони. При полном
 * номере (≥11 цифр в любом виде — «+79…», «89…») probe-запрос с дебаунсом
 * 450мс. found БЕЗ clientId — клиента в clients нет, но по номеру есть
 * брони/лиды (карточка соберётся по ним, проп phone). Ошибки сети молчат —
 * поиск не повод шуметь в форме.
 */
export interface ClientHit { found: boolean; clientId: number | null }

export function useClientByPhone(phone: string, enabled: boolean): ClientHit {
  const [hit, setHit] = useState<ClientHit>({ found: false, clientId: null });
  useEffect(() => {
    if (!enabled || phone.replace(/\D/g, "").length < 11) { setHit({ found: false, clientId: null }); return; }
    let alive = true;
    const t = window.setTimeout(() => {
      api<{ found: boolean; client_id: number | null }>(`/api/clients/by-phone?phone=${encodeURIComponent(phone)}&probe=1`)
        .then((r) => { if (alive) setHit({ found: r.found, clientId: r.client_id }); })
        .catch(() => {});
    }, 450);
    return () => { alive = false; window.clearTimeout(t); };
  }, [phone, enabled]);
  return hit;
}
